import { Component, OnInit } from '@angular/core';
import { UscStoreSchedulingService } from '../../../services/usc-store-scheduling/usc-store-scheduling-service';
import { DialogService, SessionService } from '../../../services';
import { DialogComponent } from '../../common/dialog/dialog.component';

@Component({
    selector: 'sn-usc-svt-queue-position',
    templateUrl: './usc-svt-queue-position.component.html',
    styleUrls: ['./usc-svt-queue-position.component.css']
})
export class UscSvtQueuePositionComponent implements OnInit {

    public is_not_in_active_queue: boolean = false;
    public is_front_of_the_line: boolean = false;
    public is_only_1_person_ahead: boolean = false;
    public visitor_type: string;
    public position_in_queue: number;
    public current_store_scheduler: string = '5557';
    public confirmation_number: string;
    public is_store_info_loaded:boolean = false;
    public is_queue_position_loaded:boolean = false;
    public store_info:any;
    public queue_position_unchanged:boolean = false;
    public queue_position_changed:boolean = false;
    public is_removed_from_queue_completed:boolean = false;
    public is_appointment_error_detected:boolean = false;
    public appointment_error:any;
    public refresh_in_seconds:number = 30 * 1000; // every 30 seconds
    
    public current_appt: any = {
        timeslot: null,
        firstname: "",
        lastname: "",
        mobile: "",
        email: "",
        reason_for_visit: "",
        notes: "",
        customer_type: "",
        service_type: ""
    }

    constructor(
        public uscStoreSchedulingService: UscStoreSchedulingService,
        public sessionService: SessionService,
        public dialogService: DialogService,
    ) { }

    ngOnInit() {
        this.current_store_scheduler = this.sessionService.getQueryVariable("StoreID");
        this.uscStoreSchedulingService.getStoreSchedulerInfo(this.current_store_scheduler).subscribe(
            result => {
                this.store_info = result.data;
                this.is_store_info_loaded = true;
            }, error => {
                console.log('getStoreSchedulerInfo: why this failed');
            }
        );

        this.confirmation_number = this.sessionService.getQueryVariable("cn");
        if (this.confirmation_number) {
            this.uscStoreSchedulingService.getScheduledAppointmentByConfirmationNumber(this.current_store_scheduler, this.confirmation_number).subscribe(
                result => {
                    if (result.data) {
                        if (result.data.error_code < 0) {
                            this.appointment_error = result.data;
                            this.is_appointment_error_detected = true;
                        } else {
                            this.current_appt = result.data;
                            this.loadQueuePlacement();
                        }
                    }
                }, error => {
                    console.log('getScheduledAppointmentByConfirmationNumber: why this failed');
                }
            );
        }
    }

    loadQueuePlacement() {
        if (this.is_removed_from_queue_completed || this.is_appointment_error_detected) return;  // customer left queue, no need to refresh queue placement
        this.is_queue_position_loaded = false;
        this.uscStoreSchedulingService.getAppointmentQueuePosition(this.current_store_scheduler, this.confirmation_number).subscribe(
            result => {
                this.is_queue_position_loaded = true;
                if (result.data.error_code < 0) {
                    this.appointment_error = result.data;
                    this.is_appointment_error_detected = true;
                } else if (result.data.queue_position == -1) {
                    this.is_not_in_active_queue = true;
                } else {
                    this.position_in_queue = result.data.queue_position + 1;   // queue_position is 0 based
                }
                this.is_front_of_the_line = this.position_in_queue == 1;
                this.is_only_1_person_ahead = this.position_in_queue == 2;
                // refresh queue position every 30s if needed
                if (!this.is_appointment_error_detected) setTimeout(() => { this.loadQueuePlacement() }, this.refresh_in_seconds);
            }, error => {
                console.log('getAppointmentQueuePosition: why this failed');
            }
        );                            
    }
    
    moreTime() { 
        this.queue_position_unchanged = false;
        this.queue_position_changed = false;
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: 'Processing...' });
        this.uscStoreSchedulingService.moveQueuePositionByOffset(this.current_store_scheduler, this.confirmation_number, 1).subscribe(
            result => {
                if (result.data.previous_queue_position == result.data.current_queue_position) {
                    this.queue_position_unchanged = true;
                } else {
                    this.position_in_queue = result.data.current_queue_position + 1;   // new_queue_position is 0 based
                    this.queue_position_changed = true;
                }
                this.is_front_of_the_line = this.position_in_queue == 1;
                this.is_only_1_person_ahead = this.position_in_queue == 2;
                dlg.close();
        }, error => {
                dlg.dismiss();
                console.log('moveQueuePositionByOffset: why this failed');
            }
        );          
    }

    leaveLine() {
        this.is_not_in_active_queue = false;
        this.is_queue_position_loaded = false;
        this.is_removed_from_queue_completed = false;
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: 'Processing...' });
        this.uscStoreSchedulingService.moveToInactiveQueue(this.current_store_scheduler, this.confirmation_number).subscribe(
            result => {
                dlg.close();
                this.is_removed_from_queue_completed = true;
            }, error => {
                dlg.dismiss();
                console.log('moveToInactiveQueue: why this failed');
            }
        );   
    }

    inStore() {
        this.is_not_in_active_queue = true;
        this.is_removed_from_queue_completed = false;
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: 'Processing...' });
        this.uscStoreSchedulingService.moveToActiveQueue(this.current_store_scheduler, this.confirmation_number).subscribe(
            result => {
                dlg.close();
                this.is_not_in_active_queue = false;
                this.loadQueuePlacement();
        }, error => {
                dlg.dismiss();
                console.log('moveToActiveQueue: why this failed');
            }
        );           
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-svt-queue-position/usc-svt-queue-position.component.ts